import constants from '../constants';

const getResolvedColorAlphaValue = (opacity) => {
  if (typeof opacity === 'number') {
    return Number.isFinite(opacity) ? opacity : constants.MAX_OPACITY_VALUE;
  }

  if (typeof opacity !== 'string') {
    return constants.MAX_OPACITY_VALUE;
  }

  const normalizedOpacity = opacity.trim();

  if (normalizedOpacity === '') {
    return constants.MAX_OPACITY_VALUE;
  }

  const parsedOpacity = Number(normalizedOpacity);

  if (!Number.isFinite(parsedOpacity)) {
    return constants.MAX_OPACITY_VALUE;
  }

  return parsedOpacity;
};

export default getResolvedColorAlphaValue;
